import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { CPPopupComponent } from "../../../../popup/cp-popup/cp-popup.component";
import { Observable, Subscription, timer } from 'rxjs';
import { Store } from '@ngxs/store';
import { CLIENTTYPE, IDTYPE } from 'src/app/shared/enums/index.enum';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { STEP2 } from 'src/app/interfaces/motor';
import { Router } from '@angular/router';
import { CALCULATE_PREMIUM, CANCEL_DRAFT, EDIT_CUSTOMER_PARTNER, GET_SWITCH_SITE, SAVE_AS_DRAFT, STORE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, STORE_PREMIUM_CALCULATION_PAYLOAD, STORE_PREVIOUS_CP_DETAILS } from '@store/sat-motor/sat-motor.action';
import { SharedModule } from '@shared/shared.module';
import { CustomerPartnerEditModalComponent } from '../../modal/customer-partner-edit-modal/customer-partner-edit-modal.component';
import { CustomerPartnerBase } from '@shared/classes/customer-partner.base';
import { CustomerPartnerDetailsComponent } from '../customer-partner-details/customer-partner-details.component';
import moment from 'moment';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';
import { ConfirmationModalComponent } from '@shared/components/modal/confirmation-modal/confirmation-modal.component';
import { LoadingService } from "@shared/services/loading/loading.service";
import { SaveDraftModalComponent } from '@shared/components/modal/save-draft-modal/save-draft-modal.component';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';
import { CancelDraftModalComponent } from '@shared/components/modal/cancel-draft-modal/cancel-draft-modal.component';
import { CancelDraftSuccessModalComponent } from '@shared/components/modal/cancel-draft-success-modal/cancel-draft-success-modal.component';

@Component({
  selector: 'app-customer-partner-found',
  standalone: true,
  imports: [
    SharedModule,
    CustomerPartnerEditModalComponent
  ],
  templateUrl: './customer-partner-found.component.html',
  styleUrl: './customer-partner-found.component.scss'
})
export class CustomerPartnerFoundComponent extends CustomerPartnerBase implements OnInit{
  @Output() searchAgain: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() back = new EventEmitter();
  @Input() dataSearch: STEP2.SearchDataStore;
  @Input() mkagAgent: any;
  @Input() emarketingConsentInd: boolean;

  dialogRef?: NxModalRef<any, undefined>;
  time$: Observable<number> = timer(500);
  subscription: Subscription;
  cpEditModal: boolean = false;
  componentDialogRef?: NxModalRef<CPPopupComponent>;
  cp_found:boolean = true;
  individual: boolean = false;
  company: boolean = true;
  customerEditForm: FormGroup;
  isUpdatedCP: boolean;
  eInvoiceConsent: boolean = false;
  edocConsentInd: boolean = false;
  autoRenewal: boolean = false;
  userInfo: any;
  infoMessageModal?: NxModalRef<SimpleModalComponent>;
  componentDialogRefs?: NxModalRef<SummaryPopupComponent>;
  hideSaveDraftBtn: boolean = false;

  customerEditModal?: NxModalRef<CustomerPartnerEditModalComponent>;
  isSaved: any;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;
  isQuotationGenerated: any;
  isCoverNoteGenerated: any;
  isUpdateQuotation: any;
  isRetrieveActiveQuotation: any;
  hideSearchAgain: boolean = false;
  issuanceInfo: any;
  isCoverageStepExist: boolean = false;


  constructor(
    private readonly dialogService: NxDialogService,
    private store: Store,
    private fb: FormBuilder,
    private router: Router,
    private readonly loadingService: LoadingService,
  ) {
    super();
  }

  ngOnInit() {
    this.issuanceInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step1?.issuance?.issuance);
    const step2 = this.store.selectSnapshot<any>(state => state.SatMotorState.data.step2);
    this.eInvoiceConsent = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1.issuance.pdpa.consentDetails.einvoiceConsentInd);
    this.edocConsentInd = this.store.selectSnapshot<boolean>(state => state.SatMotorState.motor.step1.issuance.pdpa.consentDetails.edocConsentInd);
    this.userInfo = this.store.selectSnapshot<any>(state => state.UserState.user);
    this.isSaved = this.store.selectSnapshot<any>((state) => state.SatMotorState?.draftDetails);
    this.isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
    this.isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
    this.isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
    this.isRetrieveActiveQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.retrieveQuotation);
    this.isCoverageStepExist = !!this.store.selectSnapshot<any>(state => state.SatMotorState?.motor?.step3);

    let isCancelReplace = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.cancelReplaceContractId);
    this.hideSaveDraftBtn = isCancelReplace || this.isQuotationGenerated || this.isCoverNoteGenerated || this.isUpdateQuotation || this.isRetrieveActiveQuotation ? true : false;
    this.hideSearchAgain = this.issuanceInfo?.cnoteType == "RN" ? true : false;
  }

  openEdit(data) {
    this.loadingService.startLoading();

    this.subscription = this.time$.subscribe(val => {
      this.customerEditModal = this.dialogService.open(CustomerPartnerEditModalComponent, {
        showCloseIcon: false,
        disableClose: true,
        width: "95%",
        maxWidth: "800px",
        data: {
          cpDetails: this.cpDetails,
          eInvoiceConsent: this.eInvoiceConsent,
          edocConsentInd: this.edocConsentInd,
          mkagAgent: this.mkagAgent,
          lov: this.lov,
          cpType: "FOUND"
        }
      });

      this.customerEditModal.afterClosed().subscribe(result => {
        if (result) {
          console.log("customer edit form data: ", result);
          this.updateCpData(result);
        }
      });

      this.loadingService.stopLoading();
      this.subscription.unsubscribe();
    });
    

  }

  restartSearch() {
    this.searchAgain.emit(true);
  }

  updateCpData(data) {
    if(data) {
      let previousCpDetails = this.store.selectSnapshot<any>(state => state.SatMotorState.motor.step2);
      this.store.dispatch(new STORE_PREVIOUS_CP_DETAILS(previousCpDetails));
      const payload = this.generateSaveCPPayload(data);
      this.store.dispatch(new EDIT_CUSTOMER_PARTNER(payload)).subscribe(res => {
        const isCPUpdated = this.store.selectSnapshot<boolean>(state => state.SatMotorState.isCPUpdated);
        if(isCPUpdated) {
          this.isUpdatedCP = true;
        }else {
          this.isUpdatedCP = false;
        }
      });
    }
    
  }

   openPopup(popup_type: any) {
  
      this.componentDialogRefs = this.dialogService.open(SummaryPopupComponent, {
        ariaLabel: "A simple dialog",
        showCloseIcon: false,
        disableClose: true,
        width: '400px',
        data: { popup_type: popup_type },
      });
    }


  generateSaveCPPayload(data) {
    const formValue = data;
    const searchCriteria = this.store.selectSnapshot(state => state.SatMotorState.data.step2.search);
    const date = new Date();
    const effectiveDate = moment(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`, 'YYYY-M-D').format('YYYY-MM-DD');
    const user = this.store.selectSnapshot<string>((state) => state.UserState.user.userId);

    const payload = {
      clientPartner: {
        partnerId: this.cpDetails?.partnerId ?? null,
        partnerVersionNo: this.cpDetails?.partnerVersionNo ?? null,
        clientAge: formValue.age,
        clientDateofBirth: formValue.dob ? moment(formValue.dob, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientEmail: formValue.email,
        clientGender: formValue.gender,
        clientMobileCode1: formValue.mobileNoCode,
        clientMobileNo1: formValue.mobileNo,
        clientName: formValue.name,
        clientNationality: formValue.nationality,
        clientMaritalStatus: formValue.maritalStatus,
        clientPartnerAddress: {
          addressId: this.cpDetails?.clientPartnerAddress?.addressId ?? null,
          addressVersionNo: this.cpDetails?.clientPartnerAddress?.addressVersionNo ?? null,
          clientUnitNo: formValue.unitNo?.trim(),
          clientAddress1: formValue.address1?.trim(),
          clientAddress2: formValue.address2?.trim(),
          clientAddress3: formValue.address3?.trim(),
          clientAddressType: formValue.addressType,
          clientCity: formValue.city,
          clientCountry: formValue.country,
          clientPhoneCode: formValue.fixedLineNoCode,
          clientPhoneNo: formValue.fixedLineNo,
          clientFax1Code: formValue.faxNoCode,
          clientFax1No: formValue.faxNo,
          clientPostcode: formValue.postCode,
          clientState: formValue.state,
          clientGeoLatitude : formValue.clientGeoLatitude,
          clientGeoLongitude : formValue.clientGeoLongitude,
          clientGeoPlaceId : formValue.clientGeoPlaceId,
          clientGeoPlusCode : formValue.clientGeoPlusCode,
          clientGeoFormattedAddress : formValue.clientGeoFormattedAddress
        },
        clientType: this.cpDetails.clientType,
        defaultMailReq: false,
        idType1: this.cpDetails.idType1,
        idType2: formValue.idType2,
        idValue1: this.cpDetails.idValue1,
        idValue2: formValue.idValue2,
        updateCustomerPartner: false,
        clientTinNo: formValue.tinNo,
        clientSstRegInd: formValue.sstRegisteredInd === 'Y' ? true : false,
        clientSstRegNo: formValue.sstNo,
        clientSstRegDate: formValue.sstEffDate && moment(formValue.sstEffDate).isValid() ? moment(formValue.sstEffDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientSstDeRegDate: formValue.sstDeRegDate && moment(formValue.sstDeRegDate).isValid() ? moment(formValue.sstDeRegDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientSstResidentStatus: formValue.sstResidentStatus,
        clientSstCountry: formValue.sstCountry,
        smeCategory: formValue.smeCategory,
        smeEndDate: formValue.smeEndDate ? moment(formValue.smeEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        smeRegisteredInd: formValue.smeRegisteredInd === 'Y' ? true : false,
        smeRegisteredNumber: formValue.smeRegNo,
        smeStartDate: formValue.smeStartDate ? moment(formValue.smeStartDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        emarketingConsentInd : this.emarketingConsentInd 
      },
      mkagAgent: this.mkagAgent,
      effectiveDate: effectiveDate,
      productType: 'MT',
      operator: user
    }

    return payload;
  }

  nextPage() {
    let custAge = this.cpDetails?.clientAge;
    let maStatus = this.cpDetails?.clientMaritalStatus;
    if(this.cpDetails.idType1 === IDTYPE.OLD_IC && this.cpDetails.idType2 !== IDTYPE.NRIC) {
      this.openNricNotUpdatePopup();
      return;
    }

    if(!this.isCompany && this.cpDetails.clientAge < 16) {
      this.openPopup("custAge");
      return;
    }
    if( (!this.isCompany) && (custAge < 16 || custAge > 99) ){
      this.openPopup("custAge");
      return;
    }

    if((!this.isCompany) && (!maStatus)){
      this.openPopup("maStatus");
      return;
    }

    let coveragePremium = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium);
    let coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coverageType);
    let previousCpDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState?.data?.step2?.previousCPDetails);
    if(previousCpDetails && coveragePremium && this.isCoverageStepExist && coverageType) {
      let calculatePremiumPayload = {
        ...coveragePremium,
        cngeNote: {
          ...coveragePremium.cngeNote,
          clientPartner: this.cpDetails
        },
        operator: this.userInfo.userId
      };
      this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD(calculatePremiumPayload)).subscribe(() => {
        this.store.dispatch(new CALCULATE_PREMIUM(calculatePremiumPayload)).subscribe((state) => {
          let cngeNote =  state?.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote;
          let vehicleDetail =  this.store.selectSnapshot<any>((state) => state?.SatMotorState?.motor?.step3?.coverage?.vehicleDetails);
          let ismRefNo = cngeNote?.riskList[0]?.ismRefNo || state.SatMotorState?.motor?.step3?.coverage?.ncdInfo?.ismRefNo;
          let cngeNoteriskList = {
            ...vehicleDetail,
            riskType: "VEH",
            ...(ismRefNo !== null && ismRefNo !== undefined ? { ismRefNo } : {}),
          };

          if (cngeNote?.riskList?.[0]) {
            this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(cngeNoteriskList));
            if (cngeNote?.riskList?.[0]?.coverList?.[0]) {
              this.store.dispatch(new STORE_COVERAGE_TYPE(cngeNote?.riskList?.[0]?.coverList?.[0]));
            }
          }
          this.store.dispatch(new STORE_PREVIOUS_CP_DETAILS(null));
          this.router.navigate(['issuance/coverage']);
        });
      });
    }else {
      this.store.dispatch(new STORE_PREVIOUS_CP_DETAILS(null));
      this.router.navigate(['issuance/coverage']);
    } 
  }

  goBack() {
    this.back.emit();
  }

  saveAsDraft() {
    this.store.dispatch(new SAVE_AS_DRAFT({ userId: this.userInfo.userId })).subscribe(state => {
      if (!state?.SatMotorState?.saveAsDraftError) {
        this.dialogService.open(SaveDraftModalComponent, {
          ariaLabel: "A simple dialog",
          showCloseIcon: false,
          disableClose: true,
          autoFocus: false,
          width: '90vw',
          maxWidth: '550px',
          data: {
            draftNo: state.SatMotorState.draftDetails.proposalNo,
          },
        })
        .afterClosed().subscribe((result) => {
          this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
            window.location.href = state.SatMotorState.data.switchSiteUrl;
          });
        });
      } else {
        this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
          showCloseIcon: false,
          disableClose: true,
          width: '95%',
          maxWidth: '400px',
          data: {
            type: "e-Quotation Saved Failed",
            message: state?.SatMotorState?.saveAsDraftError,
            btnOkLabel: "OK",
          },
        });
      }
    });
  }

  cancelDraft() {

    this.dialogService.open(CancelDraftModalComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: '90vw',
      maxWidth: '550px',
    })
    .afterClosed().subscribe(result => {
      if (result) {
        const data = {
          operator: this.userInfo.userId,
          cngeNote: this.isSaved
        };
        this.store.dispatch(new CANCEL_DRAFT(data)).subscribe(state => {
          if (state) {
            this.dialogService.open(CancelDraftSuccessModalComponent, {
              showCloseIcon: false,
              disableClose: true,
              autoFocus: false,
              width: "95vh", 
              maxWidth: "350px",
              // data: { message: "Cancel Draft Success" },
            })
            .afterClosed().subscribe((result) => {
              this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                window.location.href = state.SatMotorState.data.switchSiteUrl;
              });       	      
            });
          }
        });
      }
    });

  }

  openNricNotUpdatePopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "NRIC not updated for Policyholder. Please update."
      },
    });
  }

  openAgeNotMetPopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "Minimum age of the client is not met."
      },
    });
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  

}
